module.exports = __webpack_public_path__ + "img/ic-favorite.80439ab4.svg";